import { useState } from "react";
import { recuperarClaveApi } from "../../api/authApi";
import "../../styles/auth.css";

export default function RecuperarClavePage() {
    const [email, setEmail] = useState("");
    const [msg, setMsg] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMsg("");
        try {
            await recuperarClaveApi({ email });
            setMsg("Si el correo existe, se enviarán instrucciones de recuperación.");
        } catch (e) {
            setMsg("No se pudo procesar la solicitud.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <form className="auth-card" onSubmit={handleSubmit}>
                <h2>Recuperar contraseña</h2>
                <input type="email" placeholder="Correo" value={email} onChange={(e) => setEmail(e.target.value)} />
                <button type="submit" disabled={loading}>{loading ? "Enviando..." : "Enviar"}</button>
                {msg && <p>{msg}</p>}
            </form>
        </div>
    );
}